var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloud = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 22,
  viewBox: "0 0 50 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.84391 11.0007C11.0392 11.0007 15.7814 8.41744 18.9338 4.3299C20.2234 2.65598 21.9711 1.38347 23.9693 0.663463C25.9676 -0.0565478 28.1327 -0.193857 30.2074 0.26783C32.2822 0.729517 34.1796 1.77082 35.6744 3.26815C37.1693 4.76547 38.1988 6.65595 38.6408 8.71519C38.7786 9.34111 39.1214 9.90442 39.6158 10.3177C40.1103 10.731 40.7287 10.9711 41.3752 11.0007H44.1447C46.9103 11.0007 49.4767 12.8723 49.9181 15.5754C50.0532 16.3638 50.0132 17.1717 49.8007 17.9432C49.5883 18.7146 49.2086 19.4309 48.6881 20.0423C48.1676 20.6537 47.5187 21.1454 46.7867 21.4833C46.0546 21.8212 45.257 21.9971 44.4494 21.9987H5.54705C4.73938 21.9971 3.94176 21.8212 3.20974 21.4833C2.47772 21.1454 1.82888 20.6537 1.30835 20.0423C0.787828 19.4309 0.408132 18.7146 0.195701 17.9432C-0.016729 17.1717 -0.0567826 16.3638 0.0783041 15.5754C0.511898 12.8723 3.07828 11.0007 5.84391 11.0007Z",
  fill: "#EBEDEE"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloud.b5292818549f33ea99b5c8107e9fba56.svg";